<template>
  <section class="main__news-detail news-detail">
    <div class="news-detail__container container container_1 custom-vue-container"
         v-for="programSection in programSections" :key="programSection.code">

      <div class="news-detail__wrapper custom-vue-wrapper">
        <div class="news-detail__heading">
          <h1 class="news-detail__title text-32 text-semibold">{{ programSection.title }}</h1>
        </div>
        
        <div class="news-detail__content text-15"
             v-html="programSection.description">
        </div>

        <div class="news-detail__buttons">
          <a
              class="news-detail__button text-15 text-bold text-button button-common"
              href="/catalog/ulichnoe_sportivnoe_oborudovanie_i_ograzhdeniya/umnaya_sportivnaya_ploshchadka_prikaz_848_ot_17_10_2025g/"
          >
            Оборудование в каталоге
          </a>
        </div>
      </div>

      <section class="news-detail__workouts workouts">
        <ul class="workouts__list">
          <li class="workouts__item" v-for="(program, programIndex) in programSection.programs" :key="program.name">
            <router-link class="workouts__link" :to="{ name: 'program', params: {
                programCode: program.code,
                program: program,
                programs: programSection.programs,
                currentProgramIndex : programIndex
              }}">
              <div class="workouts__img">
                <img :src="program.preview_image" :alt="program.name">
              </div>
              <img :src="program.difficulty" alt="Сложность упражнения" class="workouts__difficulty">
              <div class="workouts__description">
                <h3 class="workouts__title text-20 text-semibold">{{ program.name }}</h3>
                <div class="workouts__text text-14">{{ program.duration }}</div>
              </div>
            </router-link>
          </li>
        </ul>
      </section>

      <div class="news-detail__wrapper">
        <div class="news-detail__content text-15">
          <h2>Техника безопасности:</h2>
          <div v-html="programSection.safety"></div>
        </div>
      </div>

    </div>
  </section>

</template>

<script>

export default {
  name: 'HomeView',
  data() {
    return {
      programSections: [],
    }
  },
  components: {},
  beforeMount() {

    console.log(this.$route)
    let that = this;
    this.axios.get('https://sfsi.ru/api/smart-workout/all')
        .then((response) => {
          that.programSections = response.data;
        })
  },
}
</script>
